
import Vue from 'vue';
import Component from 'vue-class-component';
import { UserModel } from '@/models/user.model';
import { Prop } from 'vue-property-decorator';
import { ImpactBoardMemberModel } from '@/models/impact-board-member.model';

@Component({})
export default class LeagueCard extends Vue {
  @Prop({ required: true })
  leagueUser!: ImpactBoardMemberModel;
  
  toLeagueProfile(id?: number) {
    if (id) {
      this.$router.push(`the-league-profile/${id}`);
    }
  }
}
